import { Box, TextField } from '@mui/material';

export interface OwnerTableHeaderTextInputProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onEnterPress: () => void;
  autoFocus?: boolean;
}
const OwnersTableHeaderTextInput = (props: OwnerTableHeaderTextInputProps) => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      props.onEnterPress();
    }
  };

  return (
    <Box>
      <TextField
        value={props.value}
        onChange={props.onChange}
        onKeyDown={handleKeyDown}
        autoFocus={props.autoFocus}
        fullWidth
        variant="outlined"
        InputProps={{
          sx: {
            height: '40px',
          },
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '25px',
          },
        }}
      />
    </Box>
  );
};

export default OwnersTableHeaderTextInput;
